<script>
  export let color;
  export let text;
</script>

<span style="color: {color};">
  {text}
</span>

<style>
  span {
    font-weight: 700;
  }
</style>
